export const PROPERTY_GROUPS_QUERY_KEY = {
  PROPERTY_GROUPS: "property_groups",
  CONFIG: "property_groups_config"
};
